export default ({ request }) => ({
  sysParameterListApi(data = {}) {
    return request({
      url: '/sys/parameter/list',
      method: 'post',
      data,
    })
  },
  sysParameterDetailApi(data = {}) {
    return request({
      url: '/sys/parameter/detail',
      method: 'post',
      data,
    })
  },
  sysParameterDelApi(data = {}) {
    return request({
      url: '/sys/parameter/del',
      method: 'post',
      data,
    })
  },
  sysParameterSaveApi(data = {}) {
    return request({
      url: '/sys/parameter/save',
      method: 'post',
      data,
    })
  },
})
